module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/title_banner-8f39b488ee00f309b1223a139a7049b4.png";